import React from 'react';
import { STORAGE } from '../../../constants/Storage';
import { Navigate, Outlet } from 'react-router-dom';
import { ADMIN_ROUTE_NAME } from '../../../constants/RouteName';

const AuthRoute = () => {
  const isLoggedIn = !!localStorage.getItem(STORAGE.TOKEN);

  return !isLoggedIn ? <Outlet /> : <Navigate to={ADMIN_ROUTE_NAME.STAFF_MANAGEMENT} />;
};

export default AuthRoute;
